import actionCreator from '../../../utils/actionCreator';

const shopActionTypes = [
  'GET_TOKEN_SHOP',
];

export const { types: shopTypes, actions: shopActions } = actionCreator(shopActionTypes);
